module.exports = __webpack_public_path__ + "assets/img/1013f0ffea957e88d1023939789358cd.png";